import { useRouter } from "next/router";
import { Card, EmptyState, Layout as PolarisLayout } from "@shopify/polaris";
import { Layout } from "../components/layout";

const IndexPage = () => {
  const router = useRouter();
  return (
    <Layout title={"Welcome"} fullWidth={false}>
      <PolarisLayout>
        <PolarisLayout.Section>
          <Card sectioned>
            <EmptyState
              heading="Welcome to the search experience preview"
              action={{ content: "Start Now", onAction: () => router.push("/search") }}
              image="https://reactify.com.au/images/search-logo-flat.svg"
            >
              <p>{"Preview your experience across collections or search."}</p>
            </EmptyState>
          </Card>
        </PolarisLayout.Section>
      </PolarisLayout>
    </Layout>
  );
};

export default IndexPage;
